const animals = [
  "Aale",
  "Acanthostega",
  "Adler",
  "Adlerrochen",
  "Admiral",
  "Albatros",
  "Albionbatrachus",
  "Algenfresser",
  "Amebelodon",
  "Ameise",
  "Amphicyon",
  "Amsel",
  "Anakonda",
  "Anemone",
  "Antilope",
  "Archaeomanta",
  "Archaeopteryx",
  "Argentavis",
  "Arktischer Fuchs",
  "Armfüßer",
  "Asiatischer Löwe",
  "Assel",
  "Atlantik-Krabbe",
  "Austern",
  "Bachsaibling",
  "Baptornis",
  "Barben",
  "Baummarder",
  "Berglöwe",
  "Biber",
  "Biberratte",
  "Biene",
  "Bison",
  "Blauer Rochen",
  "Blauflossen-Thunfisch",
  "Blindschleiche",
  "Boa",
  "Bonnerichthys",
  "Braune Ratte",
  "Bussard",
  "Bärenwolf",
  "Campbell-Hamster",
  "Capitosaurus",
  "Carcharocles",
  "Chamäleon",
  "Chroniosuchus",
  "Cimoliasaurus",
  "Cladoselache",
  "Coelacanth",
  "Creodont",
  "Cretoxyrhina",
  "Cryptoclidus",
  "Cynodictis",
  "Dachs",
  "Daeodon",
  "Dakosaurus",
  "Daphoenus",
  "Degenfisch",
  "Deinonychus",
  "Deinotherium",
  "Delfin",
  "Dinohyus",
  "Diplocaulus",
  "Diplocaulus",
  "Diskusfische",
  "Distelfalter",
  "Dodo",
  "Dohle",
  "Doktorfisch",
  "Dorsch",
  "Dromaeosaurus",
  "Drückerfische",
  "Dschungarischer Zwerghamster",
  "Edestus",
  "Eichhörnchen",
  "Eidechse",
  "Eisbär",
  "Elasmosaurus",
  "Elch",
  "Elefant",
  "Elefantenvogel",
  "Elster",
  "Ente",
  "Entelodon",
  "Erdkröten",
  "Eryops",
  "Esel",
  "Eule",
  "Eurypteriden",
  "Eusthenopteron",
  "Fadenfische",
  "Falken",
  "Falterfische",
  "Fasan",
  "Faultier",
  "Feldmaus",
  "Felsenhörnchen",
  "Feueranemone",
  "Feuerfisch",
  "Fischkatze",
  "Flamingo",
  "Fledermaus",
  "Fliegender-Fisch",
  "Flunder",
  "Flunder",
  "Flussotter",
  "Forelle",
  "Frosch",
  "Fuchs",
  "Fächerkoralle",
  "Gans",
  "Garnele",
  "Garnelenkrebse",
  "Gastornis",
  "Gecko",
  "Geistermuräne",
  "Gelber-Rochen",
  "Gelbflossen-Thunfisch",
  "Geoffroykatze",
  "Geosaurus",
  "Gepard",
  "Gerbil",
  "Gerrothorax",
  "Gibbon",
  "Gillicus",
  "Giraffe",
  "Glattrochen",
  "Gnu",
  "Goldforelle",
  "Goldhamster",
  "Goldstriemen",
  "Gomphotherium",
  "Gorilla",
  "Grashüpfer",
  "Grundeln",
  "Guppys",
  "Hai",
  "Hammerhai",
  "Hamster",
  "Hamstermaus",
  "Hase",
  "Hausmaus",
  "Hecht",
  "Helicoprion",
  "Hering",
  "Hermelin",
  "Hesperornis",
  "Heuschrecke",
  "Hirsch",
  "Hirschkäfer",
  "Hornisse",
  "Hornkoralle",
  "Huhn",
  "Hummel",
  "Hummer",
  "Hund",
  "Hundertfüßler",
  "Hyaenodon",
  "Hybodus",
  "Hydras",
  "Hyneria",
  "Höhlenbär",
  "Höhlenlöwe",
  "Ibis",
  "Ichthyornis",
  "Ichthyosaurus",
  "Ichthyostega",
  "Igel",
  "Iltis",
  "Jaguar",
  "Jaguarundi",
  "Kabeljau",
  "Kaiserfisch",
  "Kaiserfische",
  "Kaisergranat",
  "Kaiserkrabbe",
  "Kakadu",
  "Kalmar",
  "Kampffisch",
  "Kampffische",
  "Kanarienvogel",
  "Kaninchen",
  "Kapuzineräffchen",
  "Karakal",
  "Karaurus",
  "Kardinalfisch",
  "Karibu",
  "Karpfen",
  "Karpfenfische",
  "Kastenkoralle",
  "Katze",
  "Killifische",
  "Klapperschlange",
  "Kleiner Fuchs",
  "Knurrhähne",
  "Koala",
  "Kobras",
  "Kofferfisch",
  "Kohlweißling",
  "Kolibri",
  "Komodowaran",
  "Koolasuchus",
  "Koralle",
  "Korallenwächter",
  "Kormoran",
  "Krabbe",
  "Krabbenspinne",
  "Krake",
  "Kranich",
  "Krebstiere",
  "Kreuzspinne",
  "Krokodil",
  "Kronosaurus queenslandicus",
  "Kronosaurus",
  "Krähe",
  "Kröte",
  "Kuelana",
  "Kugelfisch",
  "Kuh",
  "Kuhhai",
  "Käfer",
  "Känguru",
  "Königsfisch",
  "Königsmakrele",
  "Labyrinthenfische",
  "Lachs",
  "Landschildkröte",
  "Languste",
  "Latimeria",
  "Laubfrösche",
  "Laufkäfer",
  "Leedsichthys",
  "Leguan",
  "Leopard",
  "Leopard",
  "Leopardmuräne",
  "Leptosuchus",
  "Libelle",
  "Liopleurodon",
  "Lippfische",
  "Lydekkerina",
  "Längenbarsch",
  "Löwe",
  "Machimosaurus",
  "Makak",
  "Makrele",
  "Makrele",
  "Makrelenhecht",
  "Mambas",
  "Mandrill",
  "Manta",
  "Manul",
  "Marabu",
  "Marder",
  "Marderbär",
  "Marderhund",
  "Margay",
  "Marienkäfer",
  "Marlins",
  "Mastodonsaurus",
  "Maultier",
  "Maulwurf",
  "Maus",
  "Meeresgrundeln",
  "Meeresotter",
  "Meeresschildkröte",
  "Meerforelle",
  "Meerschweinchen",
  "Meeräschen",
  "Megalichthys",
  "Megalodon",
  "Melanerpeton",
  "Metoposaurus",
  "Metriorhynchus",
  "Mink",
  "Mistkäfer",
  "Moa",
  "Molch",
  "Mongolische Rennmaus",
  "Moostierchen",
  "Mosasaurus",
  "Motten",
  "Murmeltier",
  "Muränen",
  "Muschel",
  "Mörserfisch",
  "Möwe",
  "Nashorn",
  "Nashornkäfer",
  "Nattern",
  "Nebelparder",
  "Neonfische",
  "Nesseltiere",
  "Nordseekrabbe",
  "Nutria",
  "Opthalmosaurus",
  "Orang-Utan",
  "Orthacanthus",
  "Osteolepis",
  "Otter",
  "Otter",
  "Ozelot",
  "Pachycormus",
  "Pachyrhizodus",
  "Palaeeudyptes",
  "Paleobatrachus",
  "Panda",
  "Panderichthys",
  "Panther",
  "Panzerwelse",
  "Papagei",
  "Papageifische",
  "Paracyclotosaurus",
  "Parapengornis",
  "Parasuchus",
  "Pavian",
  "Pazifik-Krabbe",
  "Pelagornis",
  "Pelagosaurus",
  "Pelikan",
  "Percrocuta",
  "Pfau",
  "Pfauenauge",
  "Pferd",
  "Phorusrhacos",
  "Phytosaurus",
  "Pinguin",
  "Platybelodon",
  "Platyhystrix",
  "Platys",
  "Plesiosaurus",
  "Plethodus",
  "Pliosaurus",
  "Polarfuchs",
  "Pollack",
  "Polypen",
  "Prachtbarsche",
  "Präriehunde",
  "Puma",
  "Python",
  "Quallen",
  "Quappe",
  "Rabe",
  "Ratte",
  "Redondasaurus",
  "Regenbogenfische",
  "Regenwurm",
  "Reh",
  "Reiher",
  "Rhipidistia",
  "Rhizodus",
  "Riesenalk",
  "Riesenanemone",
  "Riesenassel",
  "Riesenassel",
  "Riesenelch",
  "Riesenfaultier",
  "Riesengarnele",
  "Riesenhai",
  "Riesenkoralle",
  "Riesenkrabbe",
  "Riesenkrabbe",
  "Riesenmammut",
  "Riesenotter",
  "Riesenpinguin",
  "Riesenschnecke",
  "Riffbarsche",
  "Roborowski-Hamster",
  "Rochen",
  "Rohrkatze",
  "Rotbandgrundel",
  "Rotbarsch",
  "Rotfeuerfisch",
  "Rotkehlchen",
  "Rotzunge",
  "Rutiodon",
  "Saber-tooth Cat",
  "Saibling",
  "Salamander",
  "Sandfuchs",
  "Sandrasselotter",
  "Sardine",
  "Saugwelse",
  "Schabe",
  "Schaf",
  "Schimpanse",
  "Schlangen",
  "Schleien",
  "Schmetterling",
  "Schmetterlingsrochen",
  "Schneeleopard",
  "Scholle",
  "Schwalbe",
  "Schwalbenschwanz",
  "Schwarze-Ratte",
  "Schwarzer-Heilbutt",
  "Schwarzer-Rochen",
  "Schwarzfußkatze",
  "Schwarzmundgrundel",
  "Schwein",
  "Schwertfisch",
  "Schwertträger",
  "Schwämme",
  "Seeanemonen",
  "Seebarsch",
  "Seeforelle",
  "Seegurke",
  "Seegurke",
  "Seehecht",
  "Seeigel",
  "Seelachs",
  "Seepferdchen",
  "Seepferdchen",
  "Seepolyp",
  "Seeschnecke",
  "Seeskorpion",
  "Seespinne",
  "Seespitzschnecke",
  "Seestern",
  "Serval",
  "Seymouria",
  "Shonisaurus",
  "Skalarfische",
  "Skarabäus",
  "Skorpion",
  "Smilodon",
  "Smilosuchus",
  "Sonnenbarsch",
  "Spatz",
  "Specht",
  "Spinne",
  "Spitzhornschnecke",
  "Spitzmaus",
  "Squalicorax",
  "Steinbeißer",
  "Steinforelle",
  "Steinkoralle",
  "Steinmarder",
  "Steinschnecke",
  "Steneosaurus",
  "Steppenbison",
  "Stethacanthus",
  "Storch",
  "Strauß",
  "Stör",
  "Sumpfschildkröte",
  "Symmorium",
  "Säbelzahnlöwe",
  "Säbelzahntiger",
  "Sägefisch",
  "Sägefisch",
  "Tagpfauenauge",
  "Tausendfüßer",
  "Tausendfüßler",
  "Teddyhamster",
  "Teichmolche",
  "Temnodontosaurus",
  "Termite",
  "Terrorvogel",
  "Thunfisch",
  "Tiefseeanemone",
  "Tiefseegarnelen",
  "Tiefseekoralle",
  "Tiefseekrabbe",
  "Tiefseespinne",
  "Tiger",
  "Tigerfische",
  "Tigerhai",
  "Tiktaalik",
  "Tintenfisch",
  "Titanis",
  "Totenkopfaffe",
  "Trimerorhachis",
  "Tukan",
  "Tulerpeton",
  "Tupilakosaurus",
  "Turmdeckelschnecke",
  "Uhu",
  "Utahraptor",
  "Velociraptor",
  "Ventastega",
  "Viper",
  "Vogelspinne",
  "Wal",
  "Waldfrösche",
  "Waldkauz",
  "Waldmurmeltiere",
  "Waldwisent",
  "Wanderratte",
  "Wanze",
  "Wapiti",
  "Warane",
  "Wasserdrachen",
  "Wasserläufer",
  "Wasserratte",
  "Wasserspeier",
  "Webspinne",
  "Weichkoralle",
  "Weinbergschnecke",
  "Weißer-Hai",
  "Weißer-Heilbutt",
  "Weißflossen-Hai",
  "Wellensittich",
  "Wels",
  "Welse",
  "Wespe",
  "Wiesel",
  "Wolf",
  "Wollnashorn",
  "Wollhaarmammut",
  "Wühlmaus",
  "Wüstenfuchs",
  "Wüstenrennmaus",
  "Xenacanthus",
  "Xiphactinus",
  "Zackenbarsch",
  "Zackenbarsch",
  "Zebra",
  "Zebraapfelschnecke",
  "Zebrahai",
  "Ziege",
  "Ziesel",
  "Zikade",
  "Zitronenfalter",
  "Zitterrochen",
  "Zwerghamster",
  "Äsche",
];

const colors = [
  "adleraugenfarbender",
  "ahornfarbender",
  "akeleifarbender",
  "alabasterfarbender",
  "alexandritfarbender",
  "amazonitfarbender",
  "amethystfarbender",
  "ametrinfarbender",
  "ananasfarbender",
  "anthrazitfarbender",
  "apfelgrüner",
  "apfelgrüner",
  "aprikosenfarbbender",
  "aprikosenfarbender",
  "aprikosenoranger",
  "aprikosenoranger",
  "aquafarbender",
  "aquamarinblauer",
  "aquamarinfarbender",
  "arktisblauer",
  "arktisweißer",
  "aschegrauer",
  "aschgrauer",
  "asternvioletter",
  "asternvioletter",
  "aurorafarbender",
  "avocadofarbbender",
  "avocadogrüner",
  "avocadogrüner",
  "azuritblauer",
  "babyblauer",
  "babyrosaner",
  "bambusbrauner",
  "bambusfarbender",
  "bananengelber",
  "basaltfarbender",
  "basilikumgrüner",
  "beerenblauer",
  "beigefarbender",
  "bergseeblauer",
  "betongrauer",
  "bimssteinfarbender",
  "birkengrüner",
  "birnenblauer",
  "birnengrüner",
  "blassblauer",
  "blassgelber",
  "blassgrüner",
  "blassroter",
  "blaubeerblauer",
  "blauer",
  "blauquarzfarbender",
  "blutjaspisfarbender",
  "blutorangenroter",
  "blättergrüner",
  "blütenweißer",
  "brauner",
  "brombeerfarbbender",
  "brombeerfarbender",
  "bronzenfarbender",
  "buchenbrauner",
  "burgunderfarbender",
  "buttergelber",
  "cappuccinobrauner",
  "cappuccinofarbbender",
  "chalzedonfarbender",
  "chilir",
  "chrysoprasfarbender",
  "citrinfarbender",
  "cranberryfarbbender",
  "cranberryfarbender",
  "cremeweißer",
  "cumimbrauner",
  "cyanfarbender",
  "dahlienroter",
  "dahlienroter",
  "dattel-farbender",
  "dattelbrauner",
  "diamantweißer",
  "dillgrüner",
  "drachenfruchtfarbbender",
  "drachenfruchtfarbbender",
  "dragonfruitfarbender",
  "dschungelgrüner",
  "dunkelblauer",
  "dunkelgrüner",
  "dunkelgrüner",
  "dunkelroter",
  "dämmerungsblauer",
  "dünenbeiger",
  "edelsteinblauer",
  "edelsteingrüner",
  "edelsteinlilaer",
  "edelsteinroter",
  "edelweißfarbender",
  "eichenbrauner",
  "eierschalenfarbender",
  "eierschalenweißer",
  "eisblauer",
  "elfenbeinfarbender",
  "elfenbeinweißer",
  "erdbeerrosaner",
  "erdbeerroter",
  "erdbeerroter",
  "erikavioletter",
  "espressobrauner",
  "espressofarbbender",
  "estragongrüner",
  "eukalyptusgrüner",
  "falkenaugenfarbender",
  "feigenfarbbender",
  "feigenfarbbender",
  "feldblumengrüner",
  "felsbrauner",
  "felsgrauer",
  "fenchelgrüner",
  "feuchtgrüner",
  "feueropal",
  "feuerroter",
  "feuersteinfarbender",
  "fichtenbrauner",
  "fichtengrüner",
  "fjordblauer",
  "fliederfarbender",
  "fliederfarbender",
  "garnetfarbender",
  "gelber",
  "gelberopal",
  "glasgrüner",
  "gletscherblauer",
  "glutroter",
  "goldfarbender",
  "granatapfelroter",
  "granatapfelroter",
  "granatapfelroter",
  "granitgrauer",
  "grapefruitfarbbender",
  "grapefruitroter",
  "grashalmgrüner",
  "grauer",
  "grüner",
  "grüneropal",
  "guavenfarbbender",
  "haselnussbrauner",
  "haselnussfarbbender",
  "haselnussfarbender",
  "heidekrautfarbender",
  "heidelbeerblauer",
  "heidelbeerblauer",
  "hellblauer",
  "hellroter",
  "himbeerfarbbender",
  "himbeerfarbender",
  "himmelblauer",
  "himmelblauer",
  "holunderfarbbender",
  "holunderfarbender",
  "honiggelber",
  "hortensienfarbender",
  "howlithfarbender",
  "indigofarbender",
  "ingwerbrauner",
  "jadegrüner",
  "jaspisfarbender",
  "johannisbeerfarbender",
  "jägergrüner",
  "kaffeebrauner",
  "kakaobrauner",
  "kakaobrauner",
  "kalkweißer",
  "kamelienroter",
  "kapuzinerkressefarbbender",
  "karamellbrauner",
  "karamellfarbbender",
  "karamellfarbender",
  "kardamombrauner",
  "karminroter",
  "karneolroter",
  "kastanienbrauner",
  "kastanienbrauner",
  "kastanienfarbbender",
  "kastanienfarbender",
  "khakifarbender",
  "kiefernbrauner",
  "kieselfarbender",
  "kieselweißer",
  "kirschblütenrosaner",
  "kirschblütenrosaner",
  "kirschfarbender",
  "kirschroter",
  "kiwigrüner",
  "kiwigrüner",
  "kleefarbender",
  "kleefarbender",
  "knallblauer",
  "knallgelber",
  "knallgrüner",
  "knalllilaer",
  "knallpinker",
  "knallroter",
  "knochenweißer",
  "kobaltblauer",
  "kohlschwarzer",
  "kokosnussbrauner",
  "kokosnussfarbender",
  "korallenfarbender",
  "korallenrosaner",
  "korianderbrauner",
  "koriandergrüner",
  "kornblumenblauer",
  "kornblumenblauer",
  "kratergrauer",
  "kupferfarbender",
  "kürbisoranger",
  "labradoritfarbender",
  "lachsfarbender",
  "lachsrosaner",
  "lattebrauner",
  "lattefarbbender",
  "laubgrüner",
  "lavabrauner",
  "lavasteinfarbender",
  "lavendelfarbender",
  "lavendelfarbender",
  "leuchtblauer",
  "leuchtgelber",
  "leuchtgrüner",
  "leuchtoranger",
  "leuchtpinker",
  "leuchtsteinfarbender",
  "leuchttürkiser",
  "leuchtvioletter",
  "lichtblauer",
  "lichtgelber",
  "lichtgrauer",
  "lichtgrüner",
  "lichtlilaer",
  "lichtoranger",
  "lichtrosaner",
  "lilaer",
  "limettengrüner",
  "limonengrüner",
  "lindgrüner",
  "lycheefarbbender",
  "macadamianussbrauner",
  "macadamianussfarbbender",
  "macchiatobrauner",
  "macchiatofarbbender",
  "magenter",
  "magnesitfarbender",
  "magnolienweißer",
  "magnolienweißer",
  "mahagonibrauner",
  "mahagonifarbender",
  "malachitgrüner",
  "mandarinenfarbbender",
  "mandarinoranger",
  "mandelbrauner",
  "mandelfarbender",
  "mandelweißer",
  "mangobrauner",
  "mangofarbbender",
  "mangofarbbender",
  "mangofarbender",
  "mangrovenwaldgrüner",
  "maracujafarbbender",
  "marineblauer",
  "marmorgrauer",
  "marmorweißer",
  "melonenfarbender",
  "melonengelber",
  "milchschokoladenbrauner",
  "milchweißer",
  "minzgrüner",
  "minzgrüner",
  "minzgrüner",
  "mistelgrüner",
  "mittelgrauer",
  "mitternachtsblauer",
  "mohnroter",
  "mohnroter",
  "mokkafarbender",
  "mokkaschwarzer",
  "mondscheinweißer",
  "mondsteinfarbender",
  "moosgrüner",
  "moosgrüner",
  "morgenroter",
  "muschelblauer",
  "muskatnussbrauner",
  "nachthimmelblauer",
  "nebelweißer",
  "nelkenbrauner",
  "neonblauer",
  "neonblauer",
  "neongelber",
  "neongelber",
  "neongrüner",
  "neongrüner",
  "neonlilaer",
  "neonoranger",
  "neonoranger",
  "neonpinker",
  "neonroter",
  "neonvioletter",
  "neonweißer",
  "nordlichtgrüner",
  "nougatbrauner",
  "nougatfarbbender",
  "nussbrauner",
  "nussfarbbender",
  "obsidianfarbender",
  "olivenbrauner",
  "olivenfarbbender",
  "olivgrüner",
  "onyxschwarzer",
  "orangenfarbbender",
  "oranger",
  "orchideenfarbender",
  "oreganofarbender",
  "palmenbrauner",
  "pampelmusenoranger",
  "papayabrauner",
  "papayafarbbender",
  "papayafarbbender",
  "papayafarbbender",
  "paprikaroter",
  "passionsfruchtfarbbender",
  "passionsfruchtfarbbender",
  "pastellblauer",
  "pastellblauer",
  "pastellgelber",
  "pastellgelber",
  "pastellgrüner",
  "pastellgrüner",
  "pastelllilaer",
  "pastelloranger",
  "pastellrosaner",
  "pastellroter",
  "pastellroter",
  "pastelltürkiser",
  "pazifikblauer",
  "pekannussbrauner",
  "pekannussfarbbender",
  "peridotfarbender",
  "periwinklefarbender",
  "perlgrauer",
  "perlmuttfarbender",
  "perlweißer",
  "persimmonoranger",
  "petersiliengrüner",
  "pfefferbrauner",
  "pfirsichfarbbender",
  "pfirsichfarbender",
  "pflaumenblauer",
  "pflaumenfarbender",
  "pflaumenlilaer",
  "pistazienfarbender",
  "pistaziengrüner",
  "pistaziengrüner",
  "platinfarbender",
  "polarblauer",
  "polarfärbender",
  "polarnachtfarbender",
  "polarweißer",
  "pomelofarbender",
  "porzellanfarbender",
  "porzellangrauer",
  "preiselbeerfarbbender",
  "preiselbeerfarbender",
  "purpurfarbender",
  "quarzfarbender",
  "quarzitfarbender",
  "rattanbrauner",
  "rauchgrauer",
  "regenbogenopal",
  "regenwaldgrüner",
  "rhabarberfarbender",
  "rhodonitfarbender",
  "rosenquarzfarbender",
  "rosenroter",
  "rosenroter",
  "rosmaringrüner",
  "roter",
  "rubinroter",
  "rubinroter",
  "safranbrauner",
  "sahneweißer",
  "salbeifarbender",
  "salbeigrüner",
  "sandfarbender",
  "sandgrauer",
  "sandsteinfarbender",
  "saphirblauer",
  "saphirblauer",
  "schieferbrauner",
  "schiefergrauer",
  "schilfgrüner",
  "schlackefarbender",
  "schneegrauer",
  "schneeweißer",
  "schnittlauchgrüner",
  "schokoladenbrauner",
  "schokoladenfarbbender",
  "schokoladenfarbender",
  "schottergrauer",
  "schwarzer",
  "schwarzeropal",
  "schwärzlicher",
  "silberner",
  "smaragdgrüner",
  "smaragdgrüner",
  "sonnenaufgangsroter",
  "sonnenblumengelber",
  "sonnenblumengelber",
  "sonnenuntergangsoranger",
  "spinellfarbender",
  "steingrauer",
  "sternenweißer",
  "sternfruchtfarbbender",
  "sternfruchtfarbbender",
  "sternfruchtfarbender",
  "sturmgrauer",
  "tannenbrauner",
  "tannengrüner",
  "tannengrüner",
  "tannengrüner",
  "tanzanitfarbender",
  "teakbrauner",
  "tealfarbender",
  "teebaumgrüner",
  "terrakottafarbender",
  "thymiangrüner",
  "tigeraugenfarbender",
  "topasgelber",
  "traubenlilaer",
  "traubenlilaer",
  "trüffelbrauner",
  "tulpenroter",
  "turmalinfarbender",
  "türkisblauer",
  "türkiser",
  "vanilleweißer",
  "veilchenfarbender",
  "veilchenlilaer",
  "violetter",
  "vulkanroter",
  "wacholderbrauner",
  "wacholdergrüner",
  "waldfarnfarbender",
  "waldgrüner",
  "walnussbrauner",
  "walnussfarbbender",
  "walnussfarbender",
  "wassermelonenrosaner",
  "wassermelonenrosaner",
  "weinroter",
  "weißer",
  "wiesenblumengrüner",
  "wolkenweißer",
  "wolkenweißer",
  "zartbitterbrauner",
  "zartblauer",
  "zartgelber",
  "zartgrüner",
  "zartrosaner",
  "zartvioletter",
  "zedernbrauner",
  "ziegelroter",
  "zimtbrauner",
  "zimtfarbender",
  "zinnoberroter",
  "zirkonblauer",
  "zirkoniumfarbender",
  "zitronengelber",
  "zitronengelber",
  "zitronengelber",
  "zuckermelonenfarbender",
  "zwetschgenblauer",
  "zwetschgenfarbender",
  "zypressenbrauner",
  "zypressengrüner",
];

export function generateWordId(): string {
  const randomNumbers = new Uint8Array(3);
  crypto.getRandomValues(randomNumbers);
  const color = colors[randomNumbers[0] % colors.length];
  const name = animals[randomNumbers[1] % animals.length];
  return `${color}-${name}-${randomNumbers[2]}`;
}
